import type { ReactComponentElement } from 'react'
import { useQuery } from '@truepill/tpos-react-router'
import AccuracyScanningItem from 'components/AccuracyScanningItem'
import AccuracyScanningList from 'components/AccuracyScanningList'
import { GET_OTC_BY_SKUS } from 'gql'
import { useTaskContext } from 'providers/TaskProvider'
import type { Otc, Order } from 'types'

const OTCPackingItemListAccuracy = (props: {
  order: Order
  scanningDisabled?: boolean
}): ReactComponentElement<typeof AccuracyScanningList> => {
  const { order, scanningDisabled } = props

  const skus = order.otcProducts?.map(otcProduct => otcProduct.sku) || []
  const { data: otcs, loading: otcsLoading } = useQuery<{ getOtcBySKUS: Otc[] }>(GET_OTC_BY_SKUS, {
    variables: { customerId: order.customerId, skus },
    skip: !order.otcProducts?.length,
  })

  const { tasks } = useTaskContext()

  return (
    <AccuracyScanningList loading={!order.otcProducts || otcsLoading}>
      {order.otcProducts?.map(otcProduct => {
        const otc = otcs?.getOtcBySKUS.find(otc => otc.sku === otcProduct.sku)
        const packSize = otc?.quantity ?? 0
        const isSerialized = otc?.isSerialized
        const scansNeeded = packSize ? otcProduct.quantity / packSize : Number.NaN
        const serialNumbers = otcProduct?.serialNumbers
        const numberOfScansNotSupported = !Number.isInteger(scansNeeded)

        return (
          <AccuracyScanningItem
            key={otcProduct._id}
            orderId={order._id}
            product={{
              ...otcProduct,
              isSerialized,
              serialNumbers,
            }}
            packingData={{
              error: numberOfScansNotSupported ? 'Qty Error - Please report to your lead' : '',
              packSize,
            }}
            tasks={tasks}
            productType="OTC"
            customer={order.customer}
            location={order.location}
            scanningDisabled={scanningDisabled}
            orderStatus={order.status}
          />
        )
      })}
    </AccuracyScanningList>
  )
}

export default OTCPackingItemListAccuracy
